import { useTracking } from '@repo/tracking/use-tracking';
import { Trans, useTranslation } from '@repo/translations/use-translation';

import { Upload } from '@zooplus/icons';
import { AccordionGroup, AccordionItem, Anchor } from '@zooplus/ui-components';

import styles from './FAQSection.module.css';

export const FAQSection = () => {
  const { t } = useTranslation();
  const { trackClick } = useTracking();

  const trackFaqQuestions = (faqQuestionNumber: number) => {
    trackClick({
      target: {
        name: 'faq_section',
        id: `faq_question_${faqQuestionNumber}`,
      },
    });
  };

  return (
    <div data-testid="faq-section">
      <h2 className={styles.title}>{t('loyalty-program.faq.title')}</h2>
      <AccordionGroup size="small">
        <AccordionItem
          title={t('loyalty-program.faq.faq1.question')}
          titleElement="h3"
          onClick={() => {
            trackFaqQuestions(1);
          }}>
          <Trans
            i18nKey={'loyalty-program.faq.faq1.answer'}
            components={{
              Link: <Anchor href="/account/zooclub/dashboard" />,
            }}
          />
        </AccordionItem>
        <AccordionItem
          title={t('loyalty-program.faq.faq2.question')}
          titleElement="h3"
          onClick={() => {
            trackFaqQuestions(2);
          }}>
          <Trans
            i18nKey={'loyalty-program.faq.faq2.answer.intro'}
            components={{
              Link: <Anchor href="/account/zooclub/dashboard" />,
            }}
          />
          <ul>
            <li>
              <Trans i18nKey={'loyalty-program.faq.faq2.answer.list1'} />
            </li>
            <li>
              <Trans i18nKey={'loyalty-program.faq.faq2.answer.list2'} />
            </li>
            <li>
              <Trans i18nKey={'loyalty-program.faq.faq2.answer.list3'} />
            </li>
            <li>
              <Trans i18nKey={'loyalty-program.faq.faq2.answer.list4'} />
            </li>
          </ul>
        </AccordionItem>
        <AccordionItem
          title={t('loyalty-program.faq.faq3.question')}
          titleElement="h3"
          onClick={() => {
            trackFaqQuestions(3);
          }}>
          <ul>
            <li>
              <Trans i18nKey={'loyalty-program.faq.faq3.answer.list1'} />
            </li>
            <li>
              <Trans i18nKey={'loyalty-program.faq.faq3.answer.list2'} />
              <ul>
                <li>
                  <Trans i18nKey={'loyalty-program.faq.faq3.answer.list2.1'} />
                </li>
                <li>
                  <Trans i18nKey={'loyalty-program.faq.faq3.answer.list2.2'} />
                </li>
              </ul>
            </li>
            <li>
              <Trans i18nKey={'loyalty-program.faq.faq3.answer.list3'} />
            </li>
          </ul>
          <Trans i18nKey={'loyalty-program.faq.faq3.answer.additionalInfo'} />
        </AccordionItem>
        <AccordionItem
          title={t('loyalty-program.faq.faq4.question')}
          titleElement="h3"
          onClick={() => {
            trackFaqQuestions(4);
          }}>
          <Trans
            i18nKey={'loyalty-program.faq.faq4.answer'}
            components={{
              Link: <Anchor href="/bonuspoints/products" />,
            }}
          />
        </AccordionItem>
        <AccordionItem
          title={t('loyalty-program.faq.faq5.question')}
          titleElement="h3"
          onClick={() => {
            trackFaqQuestions(5);
          }}>
          <Trans i18nKey={'loyalty-program.faq.faq5.answer'} />
        </AccordionItem>
        <AccordionItem
          title={t('loyalty-program.faq.faq6.question')}
          titleElement="h3"
          onClick={() => {
            trackFaqQuestions(6);
          }}>
          <Trans i18nKey={'loyalty-program.faq.faq6.answer'} />
        </AccordionItem>
        <AccordionItem
          title={t('loyalty-program.faq.faq7.question')}
          titleElement="h3"
          onClick={() => {
            trackFaqQuestions(7);
          }}>
          <Trans i18nKey={'loyalty-program.faq.faq7.answer'} />
        </AccordionItem>
        <AccordionItem
          title={t('loyalty-program.faq.faq8.question')}
          titleElement="h3"
          onClick={() => {
            trackFaqQuestions(8);
          }}>
          <Trans i18nKey={'loyalty-program.faq.faq8.answer'} />
        </AccordionItem>
        <AccordionItem
          title={t('loyalty-program.faq.faq9.question')}
          titleElement="h3"
          onClick={() => {
            trackFaqQuestions(9);
          }}>
          <Trans i18nKey={'loyalty-program.faq.faq9.answer.intro'} />
          <ol>
            <li>
              <Trans
                i18nKey={'loyalty-program.faq.faq9.answer.step1'}
                components={{
                  Link: <Anchor href="/account/overview" />,
                }}
              />
            </li>
            <li>
              <Trans i18nKey={'loyalty-program.faq.faq9.answer.step2'} />
            </li>
            <li>
              <Trans i18nKey={'loyalty-program.faq.faq9.answer.step3'} />
            </li>
            <li>
              <Trans i18nKey={'loyalty-program.faq.faq9.answer.step4'} />
            </li>
          </ol>
          <Trans i18nKey={'loyalty-program.faq.faq9.answer.voucherIntro'} />
          <ul>
            <li>
              <Trans
                key={'voucherList1'}
                i18nKey={'loyalty-program.faq.faq9.answer.voucherList1'}
              />
            </li>
            <li>
              <Trans
                key={'voucherList2'}
                i18nKey={'loyalty-program.faq.faq9.answer.voucherList2'}
              />
            </li>
          </ul>
          <Trans i18nKey={'loyalty-program.faq.faq9.answer.redeemIntro'} />
          <ul>
            <li>
              <Trans key={'redeemList1'} i18nKey={'loyalty-program.faq.faq9.answer.redeemList1'} />
            </li>
            <li>
              <Trans key={'redeemList2'} i18nKey={'loyalty-program.faq.faq9.answer.redeemList2'} />
            </li>
          </ul>
          <Trans i18nKey={'loyalty-program.faq.faq9.answer.additionalInfo'} />
        </AccordionItem>
        <AccordionItem
          title={t('loyalty-program.faq.faq10.question')}
          titleElement="h3"
          onClick={() => {
            trackFaqQuestions(10);
          }}>
          <Trans i18nKey={'loyalty-program.faq.faq10.answer'} />
        </AccordionItem>
        <AccordionItem
          title={t('loyalty-program.faq.faq11.question')}
          titleElement="h3"
          onClick={() => {
            trackFaqQuestions(11);
          }}>
          <Trans
            i18nKey={'loyalty-program.faq.faq11.answer'}
            components={{
              Link: (
                <Anchor
                  href="/info/legal/club_premium_terms"
                  onClick={() => {
                    trackClick({
                      target: {
                        name: 'faq_section_landing_page',
                        id: 'terms_and_conditions_link',
                      },
                    });
                  }}
                />
              ),
            }}
          />
        </AccordionItem>
      </AccordionGroup>
      <Anchor
        href="/info/legal/club_premium_terms"
        className={styles.link}
        iconRight={(props) => <Upload size={16} {...props} />}
        onClick={() => {
          trackClick({
            target: {
              name: 'faq_section_landing_page',
              id: 'terms_and_conditions_link',
            },
          });
        }}>
        {t('loyalty-program.faq.terms')}
      </Anchor>
    </div>
  );
};
